import * as React from 'react';
import * as querystring from 'query-string';
import { browserHistory } from '../../../utilities/history';
import PropertySearchbar from './public/properties/PropertySearchbar';
import { PropertyQuery } from './public/properties/PropertyQuery';

const ProspectIndexPageSearch = () => {
    const searchProperties = (searchValue: PropertyQuery) => {
        var queryString = querystring.stringify(searchValue);
        browserHistory.push({
            pathname: 'prospect/properties',
            search: queryString
        });
    };

    return (
        <div className="index-page-searchbar">
            <PropertySearchbar valueSelected={searchProperties} />
        </div>
    );
};

export default ProspectIndexPageSearch;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/ProspectIndexPageSearch.tsx